

function isFeedbackBlocked( reason) {
    return reason.reason.includes("@") || new RegExp(/[0-9]{3,}/, "g").test(reason.reason) ||
    reason.name.includes("@") || new RegExp(/[0-9]{3,}/, "g").test(reason.name)
}

export {isFeedbackBlocked}